export default {
  header: {
    changeLanguage: '切换语言',
    expirationDate: '账号剩余{0}天',
    logout: {
      dialog: {
        title: '提示',
        content: '您确定要退出登录吗',
        positiveText: '确定',
        negativeText: '取消',
      },
      logoutSuccess: '成功退出登录',
    },
    avatar: {
      options: {
        setting: '账号设置',
        password: '更改密码',
        logout: '退出',
      },
    },
    notice: {
      message: '消息',
      readAll: '全部已读',
    },
  },
};
